import { Lock, Palette } from "lucide-react";

import { ColocaBadge } from "@/shared/components/data-display/ColocaBadge";
import useTranslations from "@/shared/lang/useTranslations";

/**
 * Covers the design panel while Coloca has not turned customization on for the organization. Drawn like the
 * rest of the page (card surface, primary tint, a plain status badge), and pinned near the top of the panel
 * so it stays on screen however long the gradient list below it grows.
 */
export function PremiumLockOverlay() {
  const { t } = useTranslations("cards");

  return (
    <div className="absolute inset-0 z-20 flex items-start justify-center rounded-2xl bg-background/60 p-4 pt-10 backdrop-blur-[2px] sm:p-6 sm:pt-16">
      <div
        role="status"
        className="sticky top-6 w-full max-w-sm rounded-2xl border border-border bg-card p-5 shadow-sm"
      >
        <div className="flex items-start justify-between gap-3">
          <span className="inline-flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
            <Palette aria-hidden="true" className="size-5" />
          </span>
          <ColocaBadge variant="secondary" icon={Lock}>
            {t("branding_locked_badge")}
          </ColocaBadge>
        </div>
        <h3 className="mt-4 text-base font-semibold text-foreground">{t("branding_locked_title")}</h3>
        <p className="mt-1 text-sm text-muted-foreground">{t("branding_locked_description")}</p>
        <p className="mt-4 border-t border-border pt-3 text-sm font-medium text-foreground">
          {t("branding_locked_cta")}
        </p>
      </div>
    </div>
  );
}
